import { render, staticRenderFns } from "./KomoditiTableDialog.vue?vue&type=template&id=e34ae08c&scoped=true"
import script from "./KomoditiTableDialog.vue?vue&type=script&lang=js"
export * from "./KomoditiTableDialog.vue?vue&type=script&lang=js"
import style0 from "./KomoditiTableDialog.vue?vue&type=style&index=0&id=e34ae08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34ae08c",
  null
  
)

export default component.exports